import { DynamicFormV2Palette } from "@mui/material";

export type FormLocationComponentTokenType = {
  textColor: string;
  iconColor: string;
  iconBackgroundColor: string;
  iconBorderColor: string;
};

export const assignLocationComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    textColor: formsPalette.text.moderate,
    iconColor: formsPalette.text.moderate,
    iconBackgroundColor: formsPalette.surface.supershy,
    iconBorderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.brand,
  } as FormLocationComponentTokenType;
};
